import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../../../../constants/common'
import { Divider } from '../../../../../Divider'
import {
  ProfileBuildingsWidgetItem,
  ProfileFlatsWidgetItem,
} from '../../../../../Widget'
import {
  PROVENANCE_ENTITY,
  PROVENANCE_FIELD,
  useRentalPortalFieldOwnership,
} from '../../../../RentalPortalProvenance'
import { useListingProfileContext } from '../../RentalPortalListingProfile.hooks'
import { ListingProfileWidgetAddressItem } from '../ListingProfileWidgetAddressItem'
import {
  getListingAddressFlatText,
  isNeedToShowListingAddressItemIcons,
} from '../RentalPortalListingProfileWidgetAddress.utils'

import * as styles from '../RentalPortalListingProfileWidgetAddress.module.css'

function ListingProfileWidgetAddressReadView() {
  const { t } = useTranslation()

  const { listingData } = useListingProfileContext()

  const flat = listingData?.flat

  const { getFieldOwnership } = useRentalPortalFieldOwnership()

  return (
    <div className={styles.addressContent}>
      <ListingProfileWidgetAddressItem
        label={t('RentalPortal.ListingProfileAddressBuildingLabelKey')}
        ownership={getFieldOwnership({
          entity: PROVENANCE_ENTITY.building,
          field: PROVENANCE_FIELD.buildingAddress,
        })}
      >
        <ProfileBuildingsWidgetItem
          isNeedToShowIcons={isNeedToShowListingAddressItemIcons}
          text={flat?.building?.address?.value}
          tooltipAdditionalText={t('Common.ClickToOpenProfileKey')}
          tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
          value={flat?.building?.id}
        />
      </ListingProfileWidgetAddressItem>
      {flat ? (
        <>
          <Divider className={styles.divider} />
          <ListingProfileWidgetAddressItem
            label={t('RentalPortal.ListingProfileAddressFlatLabelKey')}
            ownership={getFieldOwnership({
              entity: PROVENANCE_ENTITY.flat,
              field: PROVENANCE_FIELD.flatNumber,
            })}
          >
            <ProfileFlatsWidgetItem
              isNeedToShowIcons={isNeedToShowListingAddressItemIcons}
              text={getListingAddressFlatText({ flat, t })}
              value={flat.id}
            />
          </ListingProfileWidgetAddressItem>
        </>
      ) : null}
    </div>
  )
}

export default ListingProfileWidgetAddressReadView
